<div class="welcome-image"></div>

<h2 class="title">{{ 'INBOX.WELCOME_AI_CHAT.TITLE' | translate }}</h2>

<p class="subtitle">
  {{ 'INBOX.WELCOME_AI_CHAT.SUBTITLE' | translate }}
</p>

@if (aiAssistantId$ | async) {
  <button mat-flat-button color="primary" (click)="createConversation()">
    {{ 'INBOX.WELCOME_AI_CHAT.CREATE_CONVERSATION_TEXT' | translate }}
  </button>
}
